import { render, staticRenderFns } from "./shopMainpage.vue?vue&type=template&id=3f540b6c"
import script from "./shopMainpage.vue?vue&type=script&lang=js"
export * from "./shopMainpage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports